import { LanguageLevel } from '../manfredite';
// ASG-1512: Manfred Level 1 -> MAC level 2
export function getMACLanguageLevel(level) {
    switch (level) {
        case LanguageLevel.Undefined:
        case LanguageLevel.Basic:
            return 'Limited working proficiency';
        case LanguageLevel.Medium:
            return 'Professional working proficiency';
        case LanguageLevel.Fluent:
            return 'Full professional proficiency';
        case LanguageLevel.NativeBilingual:
            return 'Native or bilingual proficiency';
        default:
            return 'Limited working proficiency';
    }
}
// ASG-1512: Level 1, 2 of MAC -> Manfred Level 1
export function getLanguageLevel(level) {
    switch (level) {
        case 'Elementary proficiency':
        case 'Limited working proficiency':
            return LanguageLevel.Basic;
        case 'Professional working proficiency':
            return LanguageLevel.Medium;
        case 'Full professional proficiency':
            return LanguageLevel.Fluent;
        case 'Native or bilingual proficiency':
            return LanguageLevel.NativeBilingual;
        default:
            return LanguageLevel.Undefined;
    }
}
//# sourceMappingURL=transformations.js.map